<div>
  <div class="section-head hidden-xs nav-help-dropdown-heading">Help</div>
  <app-help-menu-item *ngFor="let menuItem of helpMenuItems$ | async" [menuItem]="menuItem"></app-help-menu-item>
  <a [href]="contactTechnicalSupportUrl" class="dropdown-item" target="_blank" id="techSupport">
    <i aria-hidden="true" class="pbi-icon-mini pbi-monitor"></i> {{ contactTechnicalSupportText }}
  </a>

  <a
    *ngIf="contactSalesAnchorText === 'Contact Sales'"
    class="dropdown-item"
    id="contactSales"
    routerLink="{{ contactSalesAnchorUrl }}"
  >
    <i aria-hidden="true" class="pbi-icon-mini pbi-telephone"></i> {{ contactSalesAnchorText }}</a
  >
  <a
    *ngIf="contactSalesAnchorText === 'Contact Mastercard Data Sources'"
    class="dropdown-item"
    id="contactMastercard"
    href="{{ contactSalesAnchorUrl }}"
  >
    <i aria-hidden="true" class="pbi-icon-mini pbi-mail-outline"></i> {{ contactSalesAnchorText }}</a
  >
</div>
